import appApi from '../../../../../../api/app-api';
import globalSettingsBranches from '../../../../../../stores/global-settings-branches';
import { toast } from 'react-toastify';

export const createNewBuildingOperation = async (
  branchId: number | undefined,
  buildingName: string,
  setIsSaveLoading: React.Dispatch<React.SetStateAction<boolean>>,
  closeDialog: () => void,
) => {
  try {
    if (buildingName.length === 0) {
      toast.warn('יש להזין את שם המבנה');
      return;
    }
    if (!branchId) {
      toast.warn('לא ניתן לארת את השלוחה');
      return;
    }
    const currentBranch = globalSettingsBranches.branches.find(
      (branchItem) => branchItem.id === branchId,
    );
    if (!currentBranch) {
      console.warn(
        `createNewBuildingOperation is failed with branchId: ${branchId} and the buildingNumber: ${buildingName}`,
      );
      toast.warn('התרחשה שגיאה נסה שוב בעוד מספר רגעים');
      return;
    }
    setIsSaveLoading(true);
    const createNewBuildingRes = await appApi.addBuildingToBranch(
      branchId,
      buildingName,
    );
    currentBranch.buildings.push(createNewBuildingRes.data.body);
    setIsSaveLoading(false);
    toast.success(`שמירת הבמנה ${buildingName} התבצעה בהצלחה`);
    closeDialog();
  } catch (e) {
    console.warn(
      `createNewBuildingOperation is failed with branchId: ${branchId} and the buildingNumber: ${buildingName} and the error: ${e}`,
    );
    toast.error(`יצירת המבנה ${buildingName} נכשלה`);
  }
};
